import api from "../api";
export default {
  namespaced: true,
  state: {
    parametrization: {},
    withdrawal_min_date: {},
    withdrawal_price: {},
    max_classified_per_store: {},
    max_classified_active: {},
  },
  getters: {
    
  },
  actions: {
    async get_by_code({ commit }, code) {
      try {
          api.get("/v1/parametrization/"+code)
          .then((res) => {
            switch (code) {
              case "withdrawal_min_date":
                commit("GET_WITHDRAWAL_MIN_DATE", res.data);
                break;
                
              case "withdrawal_price":
                commit("GET_WITHDRAWAL_PRICE", res.data);
                break;

              case "max_classified_per_store":
                commit("GET_MAX_CLASSIFIED_PER_STORE", res.data);
                break;

              case "max_classified_active":
                commit("GET_MAX_CLASSIFIED_ACTIVE", res.data);
                break;
                
              default:
                commit("GET_PARAMETRIZATION", res.data);
                break;
            }
            
          })
          .catch((error) => {
            commit("ERROR", "Erro ao carregar");
          })
          .finally(() => (
            // this.loading = false
            console.log('-')
          ));
      } catch (e) {
        commit("ERROR", e);
      }
    },
  
  },
  mutations: {
    GET_PARAMETRIZATION(state, data) {
      state.parametrization = data
    },
    GET_WITHDRAWAL_MIN_DATE(state, data){
      state.withdrawal_min_date = data
    },
    GET_WITHDRAWAL_PRICE(state, data){
      state.withdrawal_price = data
    },
    GET_MAX_CLASSIFIED_PER_STORE(state, data){
      state.max_classified_per_store = data
    },
    GET_MAX_CLASSIFIED_ACTIVE(state, data){
      state.max_classified_active = data
    },
    ERROR(state, data) {
      console.log(data)
    }
  }
}